import axios from "@/axios";
import cloneDeep from "lodash/cloneDeep";
import store from "@/store/index";

const PREV_PAGE_KEY = "prevPage";
const SEARCH_INFO_KEY = "SearchInfo";
const PAGING_INFO_KEY = "PagingInfo";

export default {
    /**
     * 검색 조건 저장
     * @param {*} type
     * @param {*} searchInfo
     * @param {*} savedSearchInfo
     * @returns
     */
    saveSearchInfo(type, searchInfo, savedSearchInfo) {
        if (type !== 1) {
            // type 2, 3 (페이징, 모달close)
            return;
        }

        // type 1 (기본 검색. 몇개씩 보기)
        savedSearchInfo.value = cloneDeep(searchInfo.value);
    },

    /**
     * 검색 조건 반환
     * @param {*} type
     * @param {*} searchInfo
     * @param {*} savedSearchInfo
     * @returns
     */
    getSearchInfo(type, searchInfo, savedSearchInfo) {
        if (type !== 1) {
            // type 2, 3 (페이징, 모달close)
            return cloneDeep(savedSearchInfo.value);
        }

        // type 1 (기본 검색, 몇개씩 보기)
        return cloneDeep(searchInfo.value);
    },

    /**
     * 테이블 헤더 조회
     * @param {*} table
     * @param {*} totalHeaders
     * @returns
     */
    async getHeaders(table, totalHeaders) {
        let result = [];
        try {
            store.commit("loading/SHOW_LOADING");
            totalHeaders = JSON.parse(JSON.stringify(totalHeaders));

            const res = await axios.post("/setting/view/company/get", {
                table: table,
            });
            if (res.data.resType === "RES_OK") {
                store.commit("loading/HIDE_LOADING");
                result = this.getConvertedHeaders(totalHeaders, res.data.resList[0].columns);
            } else {
                store.commit("loading/HIDE_LOADING");
                alert(res.data.resMsg);
            }
        } catch (error) {
            store.commit("loading/HIDE_LOADING");
            console.log(error);
        }
        return result;
    },

    /**
     * 테이블 헤더 변환
     * @param {*} totalHeaders
     * @param {*} columns
     * @returns
     */
    getConvertedHeaders(totalHeaders, columns) {
        const validColumns = columns.filter((column) => column.status);
        const result = [];

        for (const column of validColumns) {
            const targetHeader = totalHeaders.find((header) => header.title === column.colName);

            if (targetHeader) {
                targetHeader.width = column.width;
                result.push(targetHeader);
            }
        }

        return result;
    },

    saveStateForDetail(pageName, searchInfoValue, pagingInfo) {
        sessionStorage.setItem(pageName + SEARCH_INFO_KEY, JSON.stringify(searchInfoValue));
        sessionStorage.setItem(pageName + PAGING_INFO_KEY, JSON.stringify(pagingInfo));
    },

    retrieveAndClearState(pageName, detailPage, searchInfo, savedSearchInfo, pagingInfo) {
        const prevPage = sessionStorage.getItem(PREV_PAGE_KEY);
        const getSearchInfo = sessionStorage.getItem(pageName + SEARCH_INFO_KEY);
        const getPagingInfo = sessionStorage.getItem(pageName + PAGING_INFO_KEY);

        // 상세 페이지에서 복귀한 경우가 아니거나, 필요한 정보가 없으면 null 반환
        if (prevPage !== detailPage || !getSearchInfo || !getPagingInfo) {
            sessionStorage.removeItem(pageName + SEARCH_INFO_KEY);
            sessionStorage.removeItem(pageName + PAGING_INFO_KEY);
            return { type: 1, searchInfo: null, pagingInfo: null };
        }

        // 조건에 맞는 경우 (상세 페이지에서 복귀)
        const parsedSearchInfo = JSON.parse(getSearchInfo);
        const parsedPagingInfo = JSON.parse(getPagingInfo);

        searchInfo.value = cloneDeep(parsedSearchInfo);
        savedSearchInfo.value = cloneDeep(parsedSearchInfo);
        Object.assign(pagingInfo, parsedPagingInfo);

        // 조회 후, Session Storage 정리
        sessionStorage.removeItem(pageName + SEARCH_INFO_KEY);
        sessionStorage.removeItem(pageName + PAGING_INFO_KEY);

        return { type: 3, searchInfo: parsedSearchInfo, pagingInfo: parsedPagingInfo };
    },
};
